import PopularStocksCard from '@/features/market-rail/components/PopularStocksCard'
import PricesTodayCard from '@/features/market-rail/components/PricesTodayCard'
import SharesUnlockingCard from '@/features/market-rail/components/SharesUnlockingCard'
import HomeWatchlistRailBlock from '@/screens/app/home/components/HomeWatchlistRailBlock'

/**
 * Home's own right rail, in the revamp mock's order (Home mock parity, 2026-10-28): Popular
 * stocks, Prices today, Shares unlocking soon, then — for a member with a watchlist — Your
 * watchlist.
 *
 * Market news is NOT here: the mock draws none on Home (it keeps it on every other page), and the
 * main column already leads with Today's news. The shared rail on the other screens still carries
 * it. Prices today and Shares unlocking soon have no endpoint behind them yet and draw their head
 * over the generic "Not available yet" state until mm-be ships one (owner ruling 1).
 *
 * Composed here rather than passed as `ScreenLayout`'s default: that default is exactly the shared
 * rail with no per-screen block, and adding Home-only blocks to it would turn a shared component
 * into a Home-specific one for every other caller. `ScreenLayout` fits all four lists the same way
 * it fits the shared rail: rows first, then whole blocks in `RAIL_DROP_ORDER` (Shares unlocking
 * soon, Prices today, Popular stocks, Your watchlist).
 *
 * The single wrapping `<div>` sets the 40px rhythm itself (`gap-10`, the mock's, and every
 * rail's) rather than leaning on `ScreenLayout`'s `<aside>`, which only gives a screen's own
 * `rail` a flat `gap-4` between whatever top-level children it is handed.
 */
export default function HomeRail() {
  return (
    <div className="flex flex-col gap-10">
      <PopularStocksCard />
      <PricesTodayCard />
      <SharesUnlockingCard />
      <HomeWatchlistRailBlock />
    </div>
  )
}
